/* The kitten's news after a delivery (see news.tsx), over the delivery slip. */

.news {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 20;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: min(360px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px 20px 18px;
  border-radius: 20px;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: 0 12px 40px rgba(120, 80, 50, 0.15);
  animation: rise-in 0.3s cubic-bezier(0.3, 0.7, 0.4, 1.2);
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.kitten {
  width: 88px;
  height: 88px;
  animation: hop 0.45s ease-out;
}

/* Purring, the kitten sways gently. */
.purring {
  animation: sway 0.5s ease-in-out infinite alternate;
}

@keyframes hop {
  0% {
    transform: translateY(8px) scale(0.85);
  }
  60% {
    transform: translateY(-6px) scale(1.05);
  }
  100% {
    transform: none;
  }
}

@keyframes sway {
  0% {
    transform: rotate(-4deg);
  }
  100% {
    transform: rotate(4deg);
  }
}

.says {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--accent);
  animation: pop 0.25s ease-out;
}

@keyframes pop {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 1.6;
}

.lines li {
  padding: 8px 12px;
  border-radius: 12px;
  background: #fffaf3;
  border: 1px solid var(--line);
}

@media (prefers-reduced-motion: reduce) {
  .kitten,
  .purring,
  .says,
  .card {
    animation: none;
  }
}
